import "../style/contactPage.css";
import { Link } from "react-router-dom";

import { globalT } from "../utils/globalUtils.js";

export default function ContactPage(props) {
  return (
    <div className="m-contact">
      <img className="m-logo" src="images/logo.png" alt="" />
      <div className="m-subtitle">
        {globalT("Estamos aquí para ayudarte")}
        <br />
        {globalT("Si tienes cualquier duda, ¡contáctanos!")}
      </div>
      <a href="mailto:rewrite@gmail.com" className="m-mail">
        rewrite@gmail.com
      </a>
      <div className="m-text">
        <p>
          {globalT("Esta aplicación móvil ha sido financiada por el Instituto")}
          <br />
          {globalT("Universitario de Educación a Distancia")} (IUED)
          <br />
          {globalT("en la Universidad Nacional de Educación a Distancia")}
          <br />
          {globalT("en el marco de los")}{" "}
          {globalT("Proyectos de Innovación Docente")}.
           <br />
          {globalT("Ha sido diseñada por los siguientes")}{" "}
          {globalT("miembros, en colaboración con")}{" "}
          <Link
            to="https://www.dabasystem.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Dabasystem
          </Link>
          :
        </p>
        <ul>
          <li>Natalia Luisa Bellido Muñoz</li>
          <li>Paloma Blasco Fernández</li>
          <li>Imelda Katherine Brady</li>
          <li>Aurelia Carranza Márquez</li>
          <li>Gloria Chamorro Galán</li>
          <li>Carles Conrad Serra Pages</li>
          <li>Iria da Cunha Fanego</li>
          <li>Marina del Olmo Gómez</li>
          <li>María Ángeles Escobar Álvarez</li>
          <li>Luis Julián Escobar Ruiz</li>
          <li>Laura Esteban Segura</li>
          <li>María Araceli Losey León</li>
          <li>Joaquina María Pérez Pagán</li>
          <li>Sara Pistola Grille</li>
          <li>Juan Ramírez Arlandi</li>
          <li>Elena Romea Parente</li>
          <li>Antonio Rosso Ponce</li>
          <li>Silvia Sánchez Calderón</li>
          <li>Paloma Tros de Ilarduya Fernández</li>
          <li>Mónica Vilhelm Ríos</li>
        </ul>
        <p>©</p>
      </div>
    </div>
  );
}
